// @ts-nocheck
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const SpaceTeam = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: ${props => props.height || '50%'};
    padding: 5px 0;
    column-gap: 5px;
`;

const SpaceWrestler = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 100%;

    & h6.name-wrestler {
        width: calc(100% - 20px);
        font-size: 6px;
        color: white;
        text-align: center;
        margin: 0;
        padding: 0;
        font-weight: 500;
        text-transform: uppercase;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

const BoxAvatar = styled.div`
    display: flex;
    align-items: center;
    width: 20px;
    height: 20px;
    border: 1px solid white;

    & img.box-avatar-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;

function MobileRenderTeamWhenTwoInSide({ team, side }) {

    const navigate = useNavigate();

    function navigateToWrestler(wrestler) {
        navigate(`/wrestlers/i_${wrestler.id}_d_${wrestler.name}`);
    }

    function renderTeamLeftSide(team) {
        return (
            <SpaceTeam 
             className='space-team left'
            >
                {team.map((wrestler, index) => (
                    <SpaceWrestler 
                     key={index}
                     onClick={() => navigateToWrestler(wrestler)}
                     className='space-wrestler'
                    >
                        <BoxAvatar
                         className='box-avatar'
                        >
                            <img 
                             src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} 
                             alt={wrestler.name} 
                             className='box-avatar-image' 
                            />
                        </BoxAvatar>
                        <h6 className='name-wrestler'>{wrestler.name}</h6>

                    </SpaceWrestler>
                ))}
            </SpaceTeam>
        )
    }

    function renderTeamRightSide(team) {
        return (
            <SpaceTeam 
             className='space-team right'
            >
                {team.map((wrestler, index) => (
                    <SpaceWrestler 
                     key={index}
                     onClick={() => navigateToWrestler(wrestler)}
                     className='space-wrestler'
                    >
                        <h6 className='name-wrestler'>{wrestler.name}</h6>
                        <BoxAvatar
                         className='box-avatar'
                        >
                            <img 
                             src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} 
                             alt={wrestler.name} 
                             className='box-avatar-image' 
                            />
                        </BoxAvatar>
                        

                    </SpaceWrestler>
                ))}
            </SpaceTeam>
        )
    }
    
    return (
        side === 'left' ? renderTeamLeftSide(team) : renderTeamRightSide(team)
    )
}

export default MobileRenderTeamWhenTwoInSide;